/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Watch = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg viewBox="0 0 121.5 121.5" ref={ref} {...props}>
    <style>
      {
        ".st0{fill:#d9cfff}.st7{fill:#3f20ba}.st16,.st18,.st20,.st9{fill:none;stroke:#3f20ba;stroke-width:1.35;stroke-miterlimit:10}.st16,.st18,.st20{stroke-width:.75}.st18,.st20{fill:#fff}.st20{fill:none;stroke-linecap:round}"
      }
    </style>
    <g id="Layer_1">
      <path
        fill="#fff"
        d="M90.95 31.76c-5.87-3.39-18.31-11.23-22.06-10.23l-1.75-1.01a12.936 12.936 0 0 0-12.96 0L27.05 36.2c-5.09 2.94-6 9.49-2.74 13.73h-.01c-4.97 18.54-4.91 33.37 3.71 39.2l.03.06-.01-.04c.25.17.52.34.79.49 2.65 1.53 4.82 2.78 6.78 3.91.87.5 1.71.99 2.52 1.45 2.88 1.66 5.53 3.19 8.95 5.16 3.36 1.94 6.69 2.62 9.89 2.52.07 0 .13.01.2.01l-.02-.02c5.96-.23 11.48-3.15 15.89-5.69 6.82-3.94 12.53-12.46 12.53-12.46 2.37-4.11 5.41-4.09 8.97-6.14 3.56-2.06 1.78-6.03 3.52-12.51 1.76-6.56 7.2-25.85-7.1-34.11zM74.44 59.14c-4.93 2.84-8.12 3.79-9.47 8.81-1.5 5.61-3.13 9.71-10.52 13.98-3.62 2.09-5.18 3.73-5.39 5.87l-5.9 3.41c-3.23-12.06.43-23.35 5.92-26.52 3.43 1.08 7.2.71 10.39-1.13L77.58 53.1c-1.4 1.71-2.38 3.83-3.14 6.04z"
      />
      <path
        d="M63.85 58.53c1.15-.67 6.04-3.49 6.04-3.49.45-.26.72-.74.72-1.25v-.26c0-.63-.62-1.13-1.34-.71l-6.07 3.51c-.45.26-.72.74-.72 1.25v.3c0 .53.54 1.13 1.37.65z"
        className="st18"
      />
      <path
        d="M56.65 27.12c-10.35 0-18.74 4.85-18.74 10.82 0 5.98 8.39 10.82 18.74 10.82 10.35 0 18.74-4.85 18.74-10.82 0-5.97-8.39-10.82-18.74-10.82zm-1.27 8.65l-.84-3.12c-.09-.35.12-.72.47-.81s.72.12.81.47l.84 3.12c.09.35-.12.72-.47.81s-.72-.11-.81-.47zm1.27 2.73c-.53 0-.96-.25-.96-.55 0-.31.43-.55.96-.55s.96.25.96.55c0 .3-.43.55-.96.55zm16.06.11H60.24a.66.66 0 1 1 0-1.32h12.47a.66.66 0 1 1 0 1.32z"
        className="st0"
      />
      <path
        d="M86.61 31.76c2.88 1.66 2.88 5.82 0 7.48L59.47 54.92a12.936 12.936 0 0 1-12.96 0L27.05 43.68c-2.88-1.66-2.88-5.82 0-7.48-6.21 3.58-6.21 12.54 0 16.12l19.46 11.24c4.01 2.32 8.95 2.32 12.96 0L82.62 50.2c-.84-.15-1.61-.68-2-1.53-.33-.74-.38-1.83-.08-2.96.31-1.15.92-2.08 1.59-2.55 1.23-.87 2.89-.52 3.72.66.09.12.17.25.24.4 0 .01.01.01.01.02v.01c.34.74.4 1.84.09 2.98-.12.43-.28.82-.46 1.18l.89-.51c6.19-3.6 6.19-12.55-.01-16.14zM70.62 53.79c0 .52-.28.99-.72 1.25 0 0-4.89 2.82-6.04 3.49-.84.48-1.37-.12-1.37-.66v-.3c0-.52.28-.99.72-1.25l6.07-3.51c.72-.41 1.34.09 1.34.71v.27z"
        className="st0"
      />
      <path
        d="M27.05 36.2l27.14-15.67c4.01-2.32 8.95-2.32 12.96 0l19.46 11.24c2.88 1.66 2.88 5.82 0 7.48L59.47 54.92a12.936 12.936 0 0 1-12.96 0L27.05 43.68c-2.88-1.66-2.88-5.82 0-7.48z"
        className="st9"
      />
      <path
        d="M86.61 31.76c6.21 3.58 6.21 12.54 0 16.12L59.47 63.56a12.936 12.936 0 0 1-12.96 0L27.05 52.32c-6.21-3.58-6.21-12.54 0-16.12"
        className="st9"
      />
      <ellipse
        cx={62.23}
        cy={87.87}
        fill="#d9cfff"
        stroke="#3f20ba"
        strokeMiterlimit={10}
        strokeWidth={1.35}
        rx={6.79}
        ry={3.92}
      />
      <path
        d="M68.89 21.54c3.75-1 16.19 6.84 22.06 10.23 14.3 8.26 8.85 27.55 7.09 34.12-1.74 6.48.04 10.45-3.52 12.51-3.56 2.06-6.6 2.03-8.97 6.14 0 0-5.71 8.53-12.53 12.46s-16.29 8.76-25.96 3.18c-6.55-3.78-10.24-5.91-18.25-10.53-9.42-5.44-9.64-20.6-4.52-39.71"
        className="st9"
      />
      <path
        d="M49.08 64.69c-5.49 3.17-9.15 14.47-5.92 26.52l5.93-3.43M91.38 73.49c1.01 3.78-2 4.54-5.82 2.33-2.89-1.67-8.92-5.15-13.91-8.03-1.45-.84-1.91-2.58 1.41-3.47"
        className="st9"
      />
      <path
        d="M74.44 59.14c-4.93 2.84-8.12 3.79-9.47 8.81-1.5 5.61-3.13 9.71-10.52 13.98-3.92 2.26-5.42 4-5.42 6.41 0 4.41 6.2 7.99 13.84 7.99 4.01 0 7.62-.98 10.14-2.56 6.34-3.66 9.08-8.73 15.24-12.29M72.09 68.05c1.12-4.17 2.1-10.81 5.49-14.95M89.41 77.05c5.6-9.71 8.26-20.86-.82-26.11-1.42-.82-3.07-1.13-4.27-1.18M90.81 36.94c12.89 7.44 7.23 28.94 7.23 28.94M43.16 91.21c1.42 5.29 6.57 11.5 14 11.5"
        className="st9"
      />
      <g>
        <path
          d="M63.85 58.53c1.15-.67 6.04-3.49 6.04-3.49.45-.26.72-.74.72-1.25v-.26c0-.63-.62-1.13-1.34-.71l-6.07 3.51c-.45.26-.72.74-.72 1.25v.3c0 .53.54 1.13 1.37.65zM60.24 38.61h12.47a.66.66 0 1 0 0-1.32H60.24a.66.66 0 1 0 0 1.32zM56.66 35.43l-.84-3.12a.668.668 0 0 0-.81-.47c-.35.09-.56.46-.47.81l.84 3.12c.09.35.46.56.81.47.35-.09.56-.46.47-.81z"
          className="st16"
        />
        <path
          d="M55.56 38.57l-9.99 5.77M56.38 36.94l-.19-.7M59.58 37.95h-1.56"
          className="st20"
        />
        <path
          d="M84.6 49.76c-1.36.96-3.29.42-3.99-1.1-.33-.74-.38-1.83-.08-2.96.31-1.16.93-2.1 1.61-2.56l-.02.02c1.36-.96 3.27-.44 3.97 1.08"
          className="st16"
        />
        <ellipse
          cx={84.24}
          cy={46.7}
          className="st18"
          rx={3.49}
          ry={2.01}
          transform="rotate(-75.001 84.243 46.697)"
        />
        <path
          d="M42.83 98.11c-1.76-3.2-3-6.68-3.53-10.28-.53-3.59-.36-7.29.62-10.77-.86 3.51-.9 7.18-.25 10.71.64 3.53 1.98 6.91 3.81 9.97l-.65.37zM37.79 95.2c-1.76-3.2-3-6.68-3.53-10.28-.53-3.59-.36-7.29.62-10.77-.86 3.51-.9 7.18-.25 10.71.64 3.53 1.98 6.91 3.81 9.97l-.65.37zM32.75 92.29c-1.76-3.2-3-6.68-3.53-10.28-.53-3.59-.36-7.29.62-10.77-.86 3.51-.9 7.18-.25 10.71.64 3.53 1.98 6.91 3.81 9.97l-.65.37zM27.72 89.38c-1.76-3.2-3-6.68-3.53-10.28-.53-3.59-.36-7.29.62-10.77-.86 3.51-.9 7.18-.25 10.71.64 3.53 1.98 6.91 3.81 9.97l-.65.37z"
          className="st7"
        />
        <path
          d="M26.53 75.48c0 5.31 1.63 10.52 4.35 14.98l-.65.38c-2.57-4.7-3.96-10.06-3.7-15.36zM31.57 78.39c0 5.31 1.63 10.52 4.35 14.98l-.65.38c-2.57-4.7-3.96-10.06-3.7-15.36zM36.61 81.29c0 5.31 1.63 10.52 4.35 14.98l-.65.38c-2.57-4.69-3.96-10.05-3.7-15.36zM86.36 76.22c1.68-2.69 3.09-5.58 4.16-8.59-.84 3.09-2.02 6.1-3.51 8.96l-.65-.37zM82.58 74.03c1.68-2.69 3.09-5.58 4.16-8.59-.84 3.09-2.02 6.1-3.51 8.96l-.65-.37zM78.8 71.85c1.68-2.69 3.09-5.58 4.16-8.59-.84 3.09-2.02 6.1-3.51 8.96l-.65-.37zM83.62 67.78c-.64 1.88-1.39 3.74-2.28 5.54l-.65-.38c1.09-1.64 2.06-3.37 2.93-5.16zM75.02 69.67c1.68-2.69 3.09-5.58 4.16-8.59-.84 3.09-2.02 6.1-3.51 8.96l-.65-.37zM79.84 65.6c-.64 1.88-1.39 3.74-2.28 5.54l-.65-.38c1.09-1.64 2.06-3.37 2.93-5.16zM76.06 63.41c-.64 1.88-1.39 3.74-2.28 5.54l-.65-.38c1.09-1.63 2.06-3.37 2.93-5.16zM87.4 69.96c-.64 1.88-1.39 3.74-2.28 5.54l-.65-.38c1.09-1.64 2.06-3.37 2.93-5.16zM27.82 52.98l.38-3.83.37 3.83zM29.4 53.89l.38-3.83.37 3.83zM30.98 54.81l.37-3.84.38 3.84zM32.56 55.72l.37-3.84.38 3.84zM34.13 56.63l.38-3.84.37 3.84zM35.71 57.54l.37-3.84.38 3.84zM37.29 58.45l.37-3.84.38 3.84zM38.86 59.36l.38-3.84.37 3.84zM40.44 60.27l.38-3.84.37 3.84zM42.02 61.18l.37-3.84.38 3.84zM43.6 62.09l.37-3.84.38 3.84zM45.17 63l.38-3.84.37 3.84zM46.75 63.91l.37-3.84.38 3.84zM48.33 64.62l.37-3.83.38 3.83zM49.9 65.02l.38-3.84.37 3.84zM51.48 65.26l.38-3.84.37 3.84zM53.06 65.29l.37-3.84.38 3.84z"
          className="st7"
        />
        <g>
          <path d="M54.63 65.13l.38-3.84.37 3.84z" className="st7" />
        </g>
        <g>
          <path d="M56.21 64.69l.38-3.84.37 3.84z" className="st7" />
        </g>
        <g>
          <path d="M57.79 64.22l.37-3.84.38 3.84z" className="st7" />
        </g>
      </g>
      <g>
        <path
          d="M56.65 37.39c.53 0 .96.25.96.55s-.43.55-.96.55-.96-.25-.96-.55.43-.55.96-.55m0-.75c-.97 0-1.71.56-1.71 1.3s.73 1.3 1.71 1.3 1.71-.56 1.71-1.3-.74-1.3-1.71-1.3z"
          className="st7"
        />
      </g>
      <ellipse cx={56.65} cy={37.95} className="st9" rx={18.74} ry={10.82} />
    </g>
  </svg>
));
